import { WorkItemBold } from './workitem-bold';
import { ChatItem } from '../interfaces/chat-item.interface';
import { WorkItemTypes } from '../constants/workitem-types';
import { AssistedSessionType } from 'common/workitems/constants/assisted-session-types';
import { VideoSessionStatus } from 'common/common/constants/video-session-status';
import { ActiveAssistStatus } from 'common/common/constants/active-assist-status';

export class WorkItemChat extends WorkItemBold implements ChatItem {
  public messageInitialLoadIsFinished: boolean;
  public remoteControlHistoryId: string;
  public remoteControlRoute: string;
  public readonly type: string = WorkItemTypes.CHAT;
  private _assistedSessionType: AssistedSessionType;

  ActiveAssistStatus: ActiveAssistStatus;
  Closed: string;
  Created: string;
  IsAnswered?: boolean = null;
  LastAssignedAnswered: string;
  Name: string;
  PinvitationID?: string;
  VideoSessionStatus: VideoSessionStatus;

  NanorepConfigID?: string;

  constructor(workItem) {
    super(_innerConvertId(workItem));

    // Embedded DIY Integration iframes must stay in DOM to preserve state between selected workItem changes
    this.keepAlive = true;

    function _innerConvertId(workItem) {
      if (!workItem.ItemID && workItem.ChatID) {
        return { ...workItem, ItemID: workItem.ChatID };
      }
      return workItem;
    }
  }

  clearHistoryItem(): void {
    this._assistedSessionType = AssistedSessionType.NONE;
    this.remoteControlHistoryId = null;
    this.remoteControlRoute = null;
    // TODO: save state when workitems can handle their states [IG-4732]
  }

  startRCSession(): void {
    this._assistedSessionType = AssistedSessionType.REMOTE_CONTROL;
  }

  stopRCSession(): void {
    this._assistedSessionType = AssistedSessionType.NONE;
  }

  startAssistedBrowsing(): void {
    this._assistedSessionType = AssistedSessionType.ASSISTED_BROWSING;
  }

  stopAssistedBrowsing(): void {
    this._assistedSessionType = AssistedSessionType.NONE;
  }

  get hasActiveAssistedSession(): boolean {
    return this._assistedSessionType != null && this._assistedSessionType !== AssistedSessionType.NONE;
  }

  get hasActiveRemoteControl(): boolean {
    return this._assistedSessionType === AssistedSessionType.REMOTE_CONTROL;
  }

  get hasActiveAssistedBrowsing(): boolean {
    return this._assistedSessionType === AssistedSessionType.ASSISTED_BROWSING;
  }

  get hasActiveVideoSession(): boolean {
    return [
      VideoSessionStatus.InitiatedByOperator, VideoSessionStatus.InitiatedByVisitor,
      VideoSessionStatus.AcceptedByOperator, VideoSessionStatus.AcceptedByVisitor
    ].includes(this.VideoSessionStatus);
  }

  get isCollapsible() {
    return super._getCollapsible() && !this.hasActiveAssistedSession;
  }
}
